import { render, staticRenderFns } from "./tit-wrap-tertiary.vue?vue&type=template&id=0459531e&scoped=true&"
import script from "./tit-wrap-tertiary.vue?vue&type=script&lang=js&"
export * from "./tit-wrap-tertiary.vue?vue&type=script&lang=js&"
import style0 from "./tit-wrap-tertiary.vue?vue&type=style&index=0&id=0459531e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0459531e",
  null
  
)

export default component.exports